import { NavLinkPosition } from './nav.types'

export interface INavConfig {
  imgSrc: string
}

export interface INavLink {
  className?: string
  name: string
  path: string
  desktopPosition?: NavLinkPosition
  mobileIcon?: string
  clickHandler?: () => void
}
